import React, { useEffect, useState } from "react";
import { DashboardLayout } from "@/components/DashboardLayout";
import { getNav } from "@/lib/navConfig";
import { useAuth } from "@/context/AuthContext";
import api, { money } from "@/lib/api";
import { Loader2, Trophy, Briefcase, CheckCircle2 } from "lucide-react";

export default function ContractorPerformance() {
  const { user } = useAuth();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/contractors-performance").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);

  return (
    <DashboardLayout nav={getNav(user.role)} title="Contractor Performance">
      {!rows ? <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-blue-600" /></div> : (
        <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-slate-500 text-xs uppercase">
                <tr>
                  <th className="text-left px-4 py-3 font-bold">Contractor</th>
                  <th className="text-left px-4 py-3 font-bold">Trade</th>
                  <th className="text-center px-4 py-3 font-bold">Status</th>
                  <th className="text-center px-4 py-3 font-bold">Total</th>
                  <th className="text-center px-4 py-3 font-bold">Completed</th>
                  <th className="text-center px-4 py-3 font-bold">Active</th>
                  <th className="text-right px-4 py-3 font-bold">Earnings</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {rows.map((r, i) => (
                  <tr key={r.id} data-testid={`perf-row-${r.id}`} className="hover:bg-slate-50">
                    <td className="px-4 py-3 font-medium text-slate-900 flex items-center gap-2">{i === 0 && r.completed_jobs > 0 && <Trophy className="w-4 h-4 text-amber-500" />}{r.name}</td>
                    <td className="px-4 py-3 text-slate-600">{r.trade}</td>
                    <td className="px-4 py-3 text-center"><span className="text-xs px-2 py-0.5 rounded-full bg-slate-100 text-slate-700">{r.status}</span></td>
                    <td className="px-4 py-3 text-center">{r.total_jobs}</td>
                    <td className="px-4 py-3 text-center text-emerald-600 font-medium">{r.completed_jobs}</td>
                    <td className="px-4 py-3 text-center">{r.active_jobs}</td>
                    <td className="px-4 py-3 text-right font-semibold text-slate-900">{money(r.total_earnings)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {rows.length === 0 && <p className="p-8 text-center text-slate-400 text-sm">No contractors yet.</p>}
        </div>
      )}
    </DashboardLayout>
  );
}
